import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 3.821,
			width: 13,
			height: 8.357,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.935 9.267C7.059 9.431 7.221 9.561 7.406 9.648C7.591 9.736 7.795 9.777 8 9.769C8.652 9.769 9.181 9.372 9.181 8.883C9.181 8.393 8.652 7.997 8 7.997C7.347 7.997 6.819 7.6 6.819 7.11C6.819 6.62 7.347 6.224 8 6.224C8.204 6.216 8.408 6.257 8.593 6.344C8.778 6.431 8.94 6.562 9.064 6.725",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.772V10.363",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 5.638V6.227",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCash;
